import { render, staticRenderFns } from "./domestic-organization.vue?vue&type=template&id=f74867fc&scoped=true&"
import script from "./domestic-organization.vue?vue&type=script&lang=js&"
export * from "./domestic-organization.vue?vue&type=script&lang=js&"
import style0 from "./domestic-organization.vue?vue&type=style&index=0&id=f74867fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74867fc",
  null
  
)

export default component.exports